import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { Link as LinkScroll } from 'react-scroll';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            AMAN MADHAV GARG
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <LinkScroll offset={-300} to='about' delay={100} smooth={true} className='nav-links' onClick={closeMobileMenu}>
                About
              </LinkScroll>
            </li>
            <li className='nav-item'>
              <LinkScroll to='portfolio' offset={-300} delay={100} smooth={true} className='nav-links' onClick={closeMobileMenu}>
                Portfolio
              </LinkScroll>
            </li>
          </ul>
          <LinkScroll to='contact' delay={300} smooth={true} className='nav-links' onClick={closeMobileMenu}>
            {button && <Button buttonStyle='btn--outline'>Contact</Button>}
          </LinkScroll>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
